import request from "@/utils/request";
//未登录
export function IndexUnLogin(data) {
  return request({
    url: "/api/Home/IndexUnLogin",
    method: "post",
    data,
  });
}
//已登录
export function IndexLogin(data) {
  return request({
    url: "/api/Home/IndexLogin",
    method: "post",
    data,
  });
}
// 诚信优品
export function GetSuperiorItemList(data) {
  return request({
    url: "/api/Mall/GetSuperiorItemList",
    method: "post",
    data,
  });
}
//严选速达
export function GetQualityItemList(data) {
  return request({
    url: "/api/Mall/GetQualityItemList",
    method: "post",
    data,
  });
}
//车身结构
export function VehicleStructure(data) {
  return request({
    url: "/api/Mall/VehicleStructure",
    method: "post",
    data,
  });
}

//配件待拆
export function QueryVehicleAuction(data) {
  return request({
    url: "/api/Home/QueryVehicleAuction",
    method: "post",
    data,
  });
}
//配件已拆
export function QueryAutoPartsAuction(data) {
  return request({
    url: "/api/Auction/QueryAutoPartsAuction",
    method: "post",
    data,
  });
}
//发动机
export function QueryStandingAuction(data) {
  return request({
    url: "/api/Auction/QueryStandingAuction",
    method: "post",
    data,
  });
}
//有色
export function QueryWeightAuction(data) {
  return request({
    url: "/api/Auction/QueryWeightAuction",
    method: "post",
    data,
  });
}
//未登录前的竞价中心
export function QueryAuctionUnLogin(data) {
  return request({
    url: "/api/Auction/QueryAuctionUnLogin",
    method: "post",
    data,
  });
}

// 未登录前的营销活动首页

export function TopActiveUnLogin(data) {
  return request({
    url: "/api/Mall/TopActiveUnLogin",
    method: "post",
    data,
  });
}

// 已登录的营销活动首页


export function TopActive(data) {
  return request({
    url: "/api/Mall/TopActive",
    method: "post",
    data,
  });
}
//猜你喜欢
export function QueryItemList(data={}) {
  return request({
    url: "/api/Mall/QueryItemList",
    method: "post",
    data,
  });
}
export function SaveMyCart(data={}) {
  return request({
    url: "/api/MyCart/SaveMyCart",
    method: "post",
    data,
  });
}
export function TopBanner(data={}) {
  return request({
    url: "/api/Home/TopBanner",
    method: "post",
    data,
  });
}
export function TopBrand(data={}) {
  return request({
    url: "/api/Home/TopBrand",
    method: "post",
    data,
  });
}
export function TopCountry(data={}) {
  return request({
    url: "/api/Home/TopCountry",
    method: "post",
    data,
  });
}
export function GetOrderList(data={}){
  return request({
    url: "/api/Mall/GetOrderList",
    method: "post",
    data,
  });
}
export function OrderQty(data={}){
  return request({
    url: "/api/Mall/OrderQty",
    method: "post",
    data,
  });
}
export function TopOrder(data={}){
  return request({
    url: "/api/Mall/TopOrder",
    method: "post",
    data,
  });
}








